/**
 * Created by zhengyf on 2017/9/29.
 * params:
 *  productListData: [] 最近浏览的产品
 *  recentViewListWidth: number 列表容器的宽度
 */

;(function() {
    angular
        .module('DSSXAPP')
        .component('recentView', {
            template:'<div class="aliIndex-recent-review r-v-wrapper" ng-show="vm.productList.length > 0"><div class="r-v-title c-b"><h2 class="f-l"><a href="javascript:;">MY RECENTLY VIEWED ITEMS</a></h2><div class="label"></div></div><div class="r-v-content"><div class="r-v-product-box" id="r-v-product-box"><div class="r-v-product-list c-b" ng-style="vm.pListStyle"><a class="list-item f-l" target="_blank" ng-repeat="product in vm.productList track by $index" ng-href="{{product.prodDetailUrl}}"><img ng-src="{{product.img}}"></a></div></div><i class="iconfont icon-back i-back" ng-click="vm.setPListLeft(\'prev\')" ng-class="{\'able-click\': vm.isAbleClick.prev}"></i> <i class="iconfont icon-more i-more" ng-click="vm.setPListLeft(\'next\')" ng-class="{\'able-click\': vm.isAbleClick.next}"></i></div></div>',
            bindings: {
                productListData: '<',
                recentViewListWidth: '<'
            },
            controllerAs: 'vm',
            controller: recentViewCtrl
        });

    function recentViewCtrl() {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;
        vm.setPListLeft = setPListLeft;
        vm.getToken = DSSX.util.getToken;

        vm.productList = [];
        vm.pListStyle = {
            transform: 'translateX(0px)'
        };
        vm.totalLeft = 0;
        vm.left = 0;
        vm.isAbleClick = {
            prev: false,
            next: false
        }

        var COL_WIDTH = 175;
        var num = 8;
        var mistakeWidth = 70;

        // ============function==================

        function onInit() {
            console.log('[recentView init: ]');
        }

        function bindingsOnChanges(changes) {

            if (changes.productListData) {
                vm.productList = angular.copy(vm.productListData);
                initProductListWidth();
            }

            if (changes.recentViewListWidth) {
                var width = angular.copy(vm.recentViewListWidth); //
                num = Math.floor(width / COL_WIDTH);
                mistakeWidth = width - num * COL_WIDTH;
                initProductListWidth();
            }

        }

        /**
         * 初始化productList的width
         */
        function initProductListWidth() {
            var list = vm.productList;
            var width = list.length * COL_WIDTH;
            vm.pListStyle.width = width + 'px';
            vm.totalLeft = width - vm.recentViewListWidth;
            if (width < vm.recentViewListWidth) {
                setBtnStatus(false, false);
            } else {
                setBtnStatus(false, true);
            }
        }

        /**
         * 设置banner图left
         * @param option
         */
        function setPListLeft(option) {
            if (option === 'next' && !vm.isAbleClick.next) {
                return;
            }

            if (option === 'prev' && !vm.isAbleClick.prev) {
                return;
            }

            setBtnStatus(true, true);

            vm.left = option === 'next' ? (vm.left - COL_WIDTH * num) : (vm.left + COL_WIDTH * num);
            if (vm.left > 0) {
                vm.left = 0;
                setBtnStatus(false, true);
            }
            if (-vm.left > vm.totalLeft) {
                vm.left = 0 - vm.totalLeft;
                setBtnStatus(true, false);
            }
            vm.pListStyle.transform = 'translateX(' + vm.left + 'px)';
        }

        function setBtnStatus(prev, next) {
            vm.isAbleClick.prev = prev;
            vm.isAbleClick.next = next;
        }

    }


})();


